import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  switch: {
    "--colorCompoundBrandBackground": designTokens.accent[500],
    "--colorCompoundBrandBackgroundHover": designTokens.accent[600],
    "--colorCompoundBrandBackgroundPressed": designTokens.accent[700],
    marginLeft: `calc(-1 * ${designTokens.spacing[3]})`,
  },
  description: {
    marginBottom: designTokens.spacing[4],
    display: "block",
  },
  labelField: {
    marginBottom: designTokens.spacing[4],
  },
  switchContainer: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    marginBottom: designTokens.spacing[2],
  },
  infoIconWrapper: {
    display: "inline-flex",
    borderRadius: designTokens.borderRadius.sm,
    ":focus-visible": {
      outlineStyle: "solid",
      outlineWidth: "2px",
      outlineColor: designTokens.accent[500],
      outlineOffset: "2px",
    },
  },
  infoIcon: {
    color: designTokens.neutral[500],
    cursor: "help",
  },
  helpText: {
    color: designTokens.neutral[500],
    display: "block",
    marginTop: designTokens.spacing[1],
    marginBottom: designTokens.spacing[2],
    minHeight: "40px",
  },
  divider: {
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: designTokens.neutral[200],
    marginTop: designTokens.spacing[2],
    marginBottom: designTokens.spacing[4],
  },
  sliderRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  sliderInput: {
    width: "90px",
    minWidth: "90px",
    flexShrink: 0,
  },
  slider: {
    flexGrow: 1,
    minWidth: 0,
  },
  sliderMax: {
    color: designTokens.neutral[500],
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
});
